import {
  IconCheckCircle,
  IconClose,
  IconHourglass,
  IconReturn,
  IconShipping,
  Text,
  IconInventory,
} from "@idg-web-platform/pulse";
import css from "./statusBadge.module.css";
import { VNode } from "preact";
import classNames from "classnames";

export interface Status {
  kind: StatusKind;
  quantity?: string;
  totalQuantity?: string;
}

export enum StatusKind {
  Received,
  Processed,
  Shipped,
  Delivered,
  Cancelled,
  Returned,
}

type Color = "new" | "neutral" | "accented" | "striking" | "green";

export function statusStyle(status: Status): [string, Color, VNode] {
  function prefixed(suffix: string, simpleLabel: string) {
    const quantity = Number(status.quantity) || 0;
    const totalQuantity = Number(status.totalQuantity) || 0;
    return quantity < totalQuantity
      ? `${quantity} Artikel von ${totalQuantity} ${suffix}`
      : simpleLabel;
  }

  switch (status.kind) {
    case StatusKind.Received:
      return ["Eingegangen", "new", <IconInventory />];
    case StatusKind.Processed:
      return [prefixed("in Bearbeitung", "In Bearbeitung"), "neutral", <IconHourglass />];
    case StatusKind.Shipped:
      return [prefixed("versendet", "Versendet"), "green", <IconShipping />];
    case StatusKind.Delivered:
      return ["Zugestellt", "green", <IconCheckCircle />];
    case StatusKind.Cancelled:
      return [prefixed("von uns storniert", "Von uns storniert"), "striking", <IconClose />];
    case StatusKind.Returned:
      return [prefixed("zurückgesendet", "Zurückgesendet"), "accented", <IconReturn />];
  }
}

export const StatusBadge = (props: { status: Status; bordered?: boolean }) => {
  const [label, color, icon] = statusStyle(props.status);
  const bordered = props.bordered !== false;

  return (
    <div class={classNames(css.root, css[color], bordered ? css.bordered : undefined)}>
      {icon}
      <Text class={css.label} sizeStep={-1} fontStyle={"bold"} removeMargin={true} element={"span"}>
        {label}
      </Text>
    </div>
  );
};
